import React from "react";
import PersonLookup from "./PersonLookup";
import {
    providerByCompany,
    searchProviderByLastName,
    searchByFirstName
} from "../queries/ListBookingsQueries";
import { execReadBySortkey } from "../modules/DBService";

export const ProviderLookup = (props) => {
    function isEmail(input) {
        return input && input.includes("@");
    }

    async function searchProviders(input, roleFilter) {
        let providers;
        let providernameinput = input.input;

        if (providernameinput) {
            if (isEmail(providernameinput)) {
                let filter = {
                    and: [
                        { emailaddress: { beginsWith: providernameinput } },
                        { deleted: { ne: true } }
                    ]
                };

                if (roleFilter === "active") {
                    filter.and.unshift({ active: { ne: false } });
                } else if (roleFilter === "inactive") {
                    filter.and.unshift({ active: { eq: false } });
                }

                providers = await execReadBySortkey({
                    opname: "providerByCompany",
                    op: providerByCompany,
                    id: {
                        companyId: props.companyId
                    },
                    filter: filter
                });

                if (
                    providers &&
                    !providers.error &&
                    providers.items &&
                    providers.items.length
                ) {
                    providers.items.map((p) => {
                        p.name = `${p.firstname ? p.firstname : ""} ${
                            p.lastname ? p.lastname : ""
                        }`;
                    });
                    return providers.items;
                }
            } else {
                // Split the input into parts (first and last name)
                let inputparts = providernameinput.split(" ");
                let filter = {
                    and: [{ deleted: { ne: true } }]
                };

                if (roleFilter === "active") {
                    filter.and.unshift({ active: { ne: false } });
                } else if (roleFilter === "inactive") {
                    filter.and.unshift({ active: { eq: false } });
                }

                if (inputparts.length <= 2) {
                    // Search by first name
                    let provByfn = await execReadBySortkey({
                        opname: "searchByFirstName",
                        op: searchByFirstName,
                        id: { companyId: props.companyId },
                        skey: {
                            lc_fn: { beginsWith: inputparts[0].toLowerCase() }
                        },
                        filter: filter
                    });

                    // Search by last name
                    let provByLn = await execReadBySortkey({
                        opname: "searchProviderByLastName",
                        op: searchProviderByLastName,
                        id: { companyId: props.companyId },
                        skey: {
                            lc_ln: {
                                beginsWith: inputparts[1]
                                    ? inputparts[1].toLowerCase()
                                    : ""
                            }
                        },
                        filter: filter
                    });

                    let providerSet = new Set();

                    // Add providers from first name search
                    if (
                        provByfn &&
                        !provByfn.error &&
                        provByfn.items &&
                        provByfn.items.length
                    ) {
                        provByfn.items.forEach((p) => {
                            providerSet.add(JSON.stringify(p));
                        });
                    }

                    // Filter providers in providerSet based on last name
                    if (
                        provByLn &&
                        !provByLn.error &&
                        provByLn.items &&
                        provByLn.items.length
                    ) {
                        providerSet = new Set(
                            [...providerSet].filter((pJson) => {
                                let provider = JSON.parse(pJson);

                                // Check if the provider's last name matches any in the provByLn results
                                return provByLn.items.some(
                                    (lnProvider) =>
                                        lnProvider.lastname.toLowerCase() ===
                                        provider.lastname.toLowerCase()
                                );
                            })
                        );
                    }

                    let providers = [...providerSet].map((providerJson) =>
                        JSON.parse(providerJson)
                    );

                    if (providers && providers.length) {
                        providers.map((p) => {
                            p.name = `${p.firstname ? p.firstname : ""} ${p.lastname ? p.lastname : ""}`;
                        });
                        return providers;
                    }
                }
            }
        }
    }

    function setSelectedValue(prov) {
        props.setSelectedProvider(prov);
    }

    return (
        <PersonLookup
            headTextFieldName="name"
            subTextFieldName="emailaddress"
            searchService={searchProviders}
            setSelectedValue={setSelectedValue}
            placeholder="Search provider"
            userType="provider"
            initialValue={props.initialValue}
            showAdornments={props.showAdornments}
            disabled={props.disabled}
            label={props.label}
        />
    );
};
